import { Draft } from 'immer';
import { decodeJwt, JWTPayload } from 'jose';

import { Store } from 'app/interfaces';

type IdToken = JWTPayload & {
  customer_id: string;
  given_name: string;
  family_name: string;
  email: string;
  phone_number?: string;
};

const isIdToken = (idToken: ReturnType<typeof decodeJwt>): idToken is IdToken => {
  return (
    typeof idToken === 'object' &&
    idToken !== null &&
    typeof idToken.customer_id === 'string' &&
    typeof idToken.given_name === 'string' &&
    typeof idToken.family_name === 'string' &&
    typeof idToken.email === 'string'
  );
};

export default function setIdToken(state: Draft<Store.State>, idToken: string): void {
  const decodedToken = decodeJwt(idToken);

  if (isIdToken(decodedToken)) {
    state.idToken = {
      rawToken: idToken,
      customerId: decodedToken.customer_id,
      givenName: decodedToken.given_name,
      familyName: decodedToken.family_name,
      email: decodedToken.email,
      phoneNumber: decodedToken.phone_number
    };
  } else {
    if (decodedToken === null) {
      throw new Error('ID token decoding failed');
    } else {
      throw new Error('ID token is missing one or more required fields');
    }
  }
}
